import { useLocation } from 'react-router-dom';

const useQuerySearch = (): URLSearchParams => new URLSearchParams(useLocation().search);
export default useQuerySearch;
